// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1iHkV","label":"Category_label__1h7C2","content":"Category_content__1df-Y","header":"Category_header__RHC7N","location":"Category_location__2yRM8"};